export default class Slider {
  constructor($slider) {
    this.$slider = $slider;
    this.$slides = this.$slider.find('.slides > li');

    if (this.isMobile()) {
      this.handleSwipe();
    }

    this.handleNav();
  }

  isMobile() {
    return $(window).width() < 768;
  }

  handleNav() {
    this.$slider.find('.prev').click(this.prev.bind(this));
    this.$slider.find('.next').click(this.next.bind(this));
  }

  handleSwipe() {
    this.$slider.swipe({
      swipeLeft: this.next.bind(this),
      swipeRight: this.prev.bind(this),
    });
  }

  prev() {
    let index = this.$slides.filter('.active').index() - 1;

    if (index < 0) {
      let num_slides = this.isMobile() ? 1 : 2;
      index = this.$slides.length - num_slides;
    }

    this.$slides.removeClass('active active--before');
    this.$slides.eq(index).addClass('active');
    this.$slides.slice(0, index).addClass('active--before');
  }

  next() {
    let index = this.$slides.filter('.active').index() + 1;

    let num_slides = this.isMobile()
      ? this.$slides.length
      : this.$slides.length - 1;
    if (index >= num_slides) index = 0;

    this.$slides.removeClass('active active--before');
    this.$slides.eq(index).addClass('active');
    this.$slides.slice(0, index).addClass('active--before');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Slider.js